

export const PRIORITY_OPTIONS = [
    { text: 'High', value: 'high' },
    { text: 'Medium', value: 'medium' },
    { text: 'Low', value: 'low' }
]

export const SCROLL_DEBOUNCE_MS = 150
export const SCROLL_THRESHOLD = 0.85
export const TICKETS_PER_PAGE = 20
export const HIGHLIGHT_DURATION_MS = 2000
export const SEARCH_DEBOUNCE_MS = 400
export const SEARCH_MAX_LENGTH = 255
